/**
 * Copyright Mántum All Rights Reserved.
 */
import { useRef, useImperativeHandle, forwardRef } from 'react';

import type { Scroll } from '@mantum/kanela';

type PropTypes = {
    children?: React.ReactNode;
    className?: string;
    fullScreen?: boolean;
    open?: boolean;
};

export default forwardRef<Scroll, PropTypes>(function Sidebar(props, ref) {
    // prettier-ignore
    const { 
        open = false,
        fullScreen = false
    } = props;

    const bodyRef = useRef<HTMLDivElement>(null);

    const style = fullScreen ? 'mx-auto w-3/4' : 'w-full';
    const className = `${open ? 'translate-x-0' : 'translate-x-full'} ${
        !fullScreen ? 'lg:w-[640px]' : ''
    }`;

    useImperativeHandle(
        ref,
        () => {
            return {
                top(hash?: string) {
                    if (!hash) {
                        bodyRef.current?.scrollTo(0, 0);
                        return;
                    }

                    const element = document.getElementById(hash);
                    if (!element) {
                        return;
                    }

                    bodyRef.current?.scrollTo({
                        top: element.offsetTop
                    });
                }
            };
        },
        []
    );

    return (
        <aside
            className={`fixed right-0 top-0 z-20 h-screen w-full border-l-2 border-gray-100 shadow-sm ${className} ${
                props.className ?? ''
            }`}
            aria-label='Sidebar'
        >
            <div
                className='h-full w-full overflow-y-auto bg-white p-6 sm:p-8'
                ref={bodyRef}
            >
                <div className={`h-full ${style}`}>{props.children}</div>
            </div>
        </aside>
    );
});
